// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__x6t0Z","SpinnerViewport":"Spinner_SpinnerViewport__J5JpP"};